interface Params {
  startDate: string
  endDate: string
  id: string
}

export const getWebsitesPagesSum = ({ startDate, endDate, id }: Params) => {
  return `SELECT COUNT(DISTINCT page.page_id) FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}'`
}
